<!--Vista de inicio del dashboard del ORGANIZADOR LITE
    Se muestran los eventos publicados, las opciones para publicar, editar y eliminar eventos,
    también se muestran las opciones para cambiar su foto de perfíl y el banner de organizador
    y la opción de compartir url de organizador.
-->
<template>
  <v-container fluid class="px-0 pt-0">
    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->
        <v-row justify="center" class="pa-0 mb-5 pos-relative banner-container mx-0 mb-10">
          <v-img
            v-if="user.imgBackground && user.imgBackground!=''"
            :src="user.imgBackground"
            lazy-src="https://picsum.photos/id/11/10/6"
            class="banner-img"
          ></v-img>
          <div v-else class="banner-img" v-bind:style="organizerBackground"></div>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                class="d-none d-flex"
                absolute
                fab
                bottom
                right
                color="accent"
                v-on="on"
              >
                <v-icon>fas fa-pencil-alt</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Imagen de fondo</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <file-pond
                  name="event-img"
                  ref="pondHeader"
                  label-idle="Agrega un encabezado para tus eventos..."
                  accepted-file-types="image/jpeg, image/png"
                />
              </v-card-text>
              <v-card-actions class="pt-0">
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                <v-btn color="blue darken-1" text @click="processFile()">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->

        <v-row justify="center" class="my-3 mt-10">
          <v-col cols="12" class="py-0 text-center">
            <v-avatar :size="($vuetify.breakpoint.xsOnly)?200:($vuetify.breakpoint.smOnly)?200:140">
              <img :src="user.profilePicture" alt="avatar" />
              <v-dialog v-model="profileDialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-btn absolute fab top left color="accent" small v-on="on">
                    <v-icon small>fas fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <p class="display-1 px-7 pt-5 mb-2">Imagen de perfil</p>
                  <p class="body-2 px-7">La imagen tiene que ser cuadrada (Por ejemplo, 300x300 pixeles).</p>
                  <v-card-text class="pb-0">
                    <file-pond
                      name="event-img"
                      ref="pondProfile"
                      label-idle="Agrega una imagen de perfil..."
                      accepted-file-types="image/jpeg, image/png"
                    />
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="profileDialog = false">Cerrar</v-btn>
                    <v-btn color="blue darken-1" text @click="processImgOrganizer()">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-avatar>
          </v-col>
          <v-col cols="12" class="py-0 text-center">
            <h1 class="display-2 font-weight-bold">{{ user.companyName }}
              <v-chip color="grey lighten-1" text-color="white">
                <span class="subtitle-2 d-sm-flex"><strong>LITE</strong></span>
              </v-chip>
            </h1>
          </v-col>
        </v-row>
        <v-row justify="center" class="organizer-content">
          <v-col cols="12" md="6" class="text-center ma-2">
            <v-row justify="space-between">
              <v-col cols="12" sm="6" class="px-8">
                <v-btn class="display-1 white--text custom-transform-class text-none elevation-2" color="primary" x-large height="50" to="/dashboard/nuevo-evento-lite" block>
                  Nuevo evento
                  <!--<v-icon class="pl-5" right x-large>mdi-plus</v-icon>-->
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="px-8">
                <v-tooltip top max-width="350px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="display-1 white--text custom-transform-class text-none elevation-2" color="primary" style="border-width: 2px;" outlined x-large height="50" block v-clipboard:copy="message"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
                      <strong>Compartir eventos</strong>
                    </v-btn>
                  </template>
                  <span>Copiar y compartir la URL que dirige a tu calendario personalizado con todos tus cursos y eventos.</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="11" xl="10">
            <product-list :loading="loading" :items="filteredEvents" itemsPerPage=8></product-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
  </v-container>
</template>
<script>
import productList from "@/components/shared/products/productList";
import { validations } from "@/helpers/validations.js";
import { imageHelper } from "@/helpers/imageProcessing.js";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import * as Vibrant from "node-vibrant";

// Plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Filepond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

//VueFilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  components: {
    productList,
    FilePond
  },
  data() {
    return {
      loading: true,
      dialog: false,
      profileDialog: false,
      message: "",
      organizer: {
        imgBackground: ""
      },

      categoriesItems: [
        { item: "Todos" },
        {
          item: "HEADER#Ciencias Físico Matemáticas e Ingenierías",
          value: "Ciencias Físico Matemáticas e Ingenierías"
        },
        { item: "Ingeniería Mecánica", value: "Ingeniería Mecánica" },
        { item: "Ingeniería Eléctrica", value: "Ingeniería Eléctrica" },
        { item: "Química", value: "Química" },
        {
          item: "Medio ambiente y sustentabilidad",
          value: "Medio ambiente y Sustentabilidad"
        },
        { item: "Física y Astronomía", value: "Física y Astronomía" },
        {
          item: "Ciencias de la Computación",
          value: "Ciencias de la Computación"
        },
        {
          item: "Tecnologías de Información",
          value: "Tecnologías de Información"
        },
        {
          item: "HEADER#Ciencias Biológicas y de la Salud",
          value: "Ciencias Biológicas y de la Salud"
        },
        { item: "Medicina", value: "Medicina" },
        { item: "Nutrición", value: "Nutrición" },
        { item: "Fisioterapia", value: "Fisioterapia" },
        { item: "Odontología", value: "Odontología" },
        { item: "Salud Animal", value: "Salud Animal" },
        { item: "Enfermería", value: "Enfermería" },
        { item: "Belleza", value: "Belleza" },
        { item: "HEADER#Ciencias Sociales", value: "Ciencias Sociales" },
        { item: "Economía", value: "Economía" },
        { item: "Educación", value: "Educación" },
        { item: "Gobierno", value: "Gobierno" },
        { item: "Derecho", value: "Derecho" },
        { item: "HEADER#Negocios", value: "Negocios" },
        { item: "Finanzas", value: "Finanzas" },
        { item: "Contabilidad", value: "Contabilidad" },
        { item: "Marketing", value: "Marketing" },
        { item: "Estrategia", value: "Estrategia" },
        { item: "Gestión", value: "Gestión" },
        { item: "Diseño", value: "Diseño" },
        { item: "Manufactura", value: "Manufactura" },
        {
          item: "HEADER#Humanidades y de las Artes",
          value: "Humanidades y de las Artes"
        },
        { item: "Música", value: "Música" },
        { item: "Artes Plásticas", value: "Artes Plásticas" },
        { item: "Historia", value: "Historia" },
        { item: "Filosofía", value: "Filosofía" },
        { item: "HEADER#Multidisciplinaria", value: "Multidisciplinaria" },
        { item: "Emprendimiento", value: "Emprendimiento" },
        { item: "Habilidades Blandas", value: "Habilidades Blandas" },
        { item: "Industria 4.0", value: "Industria 4.0" },
        { item: "HEADER#Desarrollo Personal", value: "Desarrollo Personal" },
        { item: "Idiomas", value: "Idiomas" },
        { item: "Oratoria", value: "Oratoria" },
        { item: "Comunicación", value: "Comunicación" },
        { item: "Ortografía", value: "Ortografía" },
        { item: "Trabajo en Equipo", value: "Trabajo en Equipo" },
        { item: "Liderazgo", value: "Liderazgo" }
      ],
      typeItems: [
        { item: "Todas", value: "Todas" },
        { item: "Presencial", value: "ON_SITE" },
        { item: "En línea", value: "ON_LINE" }
      ],
      organizerBackground: ""
    };
  },
  methods: {
    ...mapMutations("event", ["setFilter"]),
    ...mapActions("event", ["fetchUserEvents"]),
    ...mapActions("user", ["updateUser"]),
    ...mapMutations("notifications", ["show"]),
    handleFilePondInit: function() {},
    /**
     * Función para actualizar la imagen del encabezado del organizador
     */
    async processFile() {
      const file = this.$refs.pondHeader.getFiles()[0].file;
      this.show({ text: "Estamos guardando la imagen... 📷" });
      this.user.imgBackground = await imageHelper.resizeImg(file, 1500, 600);
      await this.updateOrganizerPicture();
      this.show({ text: "¡Encabezado actualizado con éxito!" });
      this.dialog = false;
      this.$refs.pondHeader.removeFiles();
    },
    /**
     * Función para actualizar imagen de perfíl de organizador
     */
    async processImgOrganizer() {
      const file = this.$refs.pondProfile.getFiles()[0].file;
      this.show({ text:"Estamos guardando la imagen... 📷"});
      this.user.profilePicture = await imageHelper.resizeImg(file, 600, 600);
      await this.updateProfilePicture();
      this.profileDialog = false;
      this.$refs.pondProfile.removeFiles();
    },
    /**
     * Función para guardar la imagen del encabezado en el bucket de S3 de Amazon
     */
    async updateOrganizerPicture(){
      this.user.imgBackground = await imageHelper.saveImage(this.user.imgBackground);
      this.updateUser(this.user);
      this.show({ text:"Imagen de perfíl actualizada con éxito !"});
    },
    /**
     * Función para guardar la imagen de perfíl en el bucket de S3 de Amazon
     */
    async updateProfilePicture(){
      this.user.profilePicture = await imageHelper.saveImage(this.user.profilePicture);
      this.updateUser(this.user);
      this.show({ text:"Imagen de perfíl actualizada con éxito !"});
    },
    /**
     * Función para poner un color degradado de fondo en el encabezado, 
     * en caso de que el organizador no cuente con imagen de encabezado.
     * LA IMAGEN QUE SE TOMA PARA PONER EL COLOR DE FONDO DEL DEGRADADO ES LA DE PERFIL DE ORGANIZADOR.
     */
    async getOrganizerBackground() {
      let newImg = `${this.user.profilePicture}?q=${Date.now()}`;
      let { LightVibrant, DarkVibrant } = await Vibrant.from(newImg)
        .maxColorCount(2)
        .getPalette();
      this.organizerBackground = `background-image: linear-gradient(315deg, ${LightVibrant.hex} 0%, ${DarkVibrant.hex} 74%);`;
    },
    onCopy: function(e) {
      this.show({
        text: "¡Se ha copiado la url de los eventos al portapapeles! 😄"
      });
    },
    onError: function(e) {
      this.show({ text: "¡Hubo un problema al copiar la url de los eventos!" });
    }
  },
  computed: {
    ...mapGetters("event", ["filteredEvents"]),
    ...mapState("user", ["user"])
  },
  async mounted() {
    await this.getOrganizerBackground();
    await this.fetchUserEvents();
    this.loading = false;
    this.message = `https://v2.wechamber.mx/eventos-organizador/${this.user.id}`;
  }
};
</script>
<style scoped>
@media (max-width: 959px) {
  .v-btn-toggle {
    flex-direction: column !important;
  }
}

.banner-img {
  height: 65vh;
  width: auto;
  flex: none;
}
.banner-container {
  height: 65vh;
  width: 100%;
  position: relative;
}
.banner-content {
  position: absolute;
  height: 500px;
  bottom: -250px;
  transition: 0.13s all ease-in-out;
}

@media (max-width: 599px) {
  .banner-img {
    height: auto;
    width: auto;
    flex: none;
  }
  .banner-container {
    height: 200px;
    position: relative;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: 0px;
    transition: 0.13s all ease-in-out;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .banner-img,
  .banner-container {
    height: 300px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .sponsor-img {
    max-height: 85px;
    max-width: 110px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
@media (min-width: 1264px) and (max-width: 1599px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }

}
@media (min-width: 1599px) and (max-width: 1903px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 500px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 200px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
@media (min-width: 1904px) {
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 400px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    height: 230px;
    bottom: -100px;
    transition: 0.13s all ease-in-out;
  }
}
</style>
